// extracted by mini-css-extract-plugin
export default {"outer":"layout_outer__IoSNs","inner":"layout_inner__5jEPq","formWrapper":"layout_formWrapper__-QEAS","logoWrapper":"layout_logoWrapper__P4ZXW"};